import { Injectable } from "@angular/core";
import { v7 as uuidv7 } from "uuid";

@Injectable({ providedIn: "root" })
export class IdGeneratorService {

    private uniqueNumericId = 0;

    getUniqueNumericId() {

        return ++this.uniqueNumericId;
    }

    getUuid() {

        return uuidv7();
    }

    generateTraceId() {

        const traceId = uuidv7()
            .replace(/-/g, "");

        const spanId = uuidv7()
            .replace(/-/g, "")
            .slice(16, 32);

        return [
            "00", // version
            traceId,
            spanId,
            "01", // 01 to signal other span generators to export their trace info
        ].join("-");
    }
}
